// extracted by mini-css-extract-plugin
export default {"wrapper":"StoryMenuInfo__wrapper--KLi2l","title":"StoryMenuInfo__title--tnIvK","subTitle":"StoryMenuInfo__subTitle--39uZK"};